import { render, staticRenderFns } from "./examination_room_list.vue?vue&type=template&id=beba2860&scoped=true"
import script from "./examination_room_list.vue?vue&type=script&lang=js"
export * from "./examination_room_list.vue?vue&type=script&lang=js"
import style0 from "./examination_room_list.vue?vue&type=style&index=0&id=beba2860&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beba2860",
  null
  
)

export default component.exports